export default __webpack_public_path__ + "static/media/Frame 2087.072e6a33.png";